import FinanceRoutes from "./financeRoutes";

export default FinanceRoutes;
